import type { SyncResponse, ZenSession } from "@qz/shared";

const DISCLAIMER_KEY = "qz_disclaimer_accepted";
const SESSION_KEY = "qz_session";

/** Estado em memória do app. Não persiste em storage. */
export const state = {
  /** Sessão (cookies do portal Zen). Reidratada de sessionStorage no boot. */
  session: null as ZenSession | null,
  /** Resposta do /api/sync. Apenas em memória. */
  data: null as SyncResponse | null,
};

// ---------------- Disclaimer ----------------

export function disclaimerAccepted(): boolean {
  return localStorage.getItem(DISCLAIMER_KEY) === "1";
}

export function acceptDisclaimer() {
  localStorage.setItem(DISCLAIMER_KEY, "1");
}

// ---------------- Sessão ----------------
//
// Guardamos a sessão em sessionStorage (some ao fechar a aba). Nunca em
// localStorage. A senha do user nunca é armazenada em lugar nenhum.

export function loadSession(): ZenSession | null {
  const raw = sessionStorage.getItem(SESSION_KEY);
  if (!raw) return null;
  try {
    state.session = JSON.parse(raw) as ZenSession;
    return state.session;
  } catch {
    sessionStorage.removeItem(SESSION_KEY);
    return null;
  }
}

export function saveSession(s: ZenSession) {
  state.session = s;
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(s));
}

export function clearSession() {
  state.session = null;
  state.data = null;
  sessionStorage.removeItem(SESSION_KEY);
}
